import type { ImpactItemProps } from "../types";

export function ImpactItem({ value, description }: ImpactItemProps) {
  return (
    <div>
      <h2 className="mb-1 text-2xl font-medium tracking-label text-green-1000 lg:text-3xl xl:text-4xl">
        {value}
      </h2>
      <p className="text-black-100 text-sm lg:text-md">{description}</p>
    </div>
  );
}
